import styles from './LoreChapter.module.css';
import sleepImage from '../../assets/lore/sleep.png';
import pactImage from '../../assets/lore/pact.png';
import vesselImage from '../../assets/lore/vessel.png';
import descendImage from '../../assets/lore/descend.png';

const ILLUSTRATIONS = {
  'I': sleepImage,
  'II': pactImage,
  'III': vesselImage,
  'IV': descendImage,
};

function IllustrationPlaceholder({ chapter, color }) {
  return (
    <svg
      viewBox="0 0 500 600"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '100%', height: '100%', position: 'absolute', inset: 0 }}
    >
      <defs>
        <radialGradient id={`g${chapter.index}`} cx="50%" cy="45%" r="55%">
          <stop offset="0%" stopColor={color} stopOpacity="0.18" />
          <stop offset="100%" stopColor="#05050a" stopOpacity="1" />
        </radialGradient>
      </defs>
      <rect width="500" height="600" fill="#05050a" />
      <rect width="500" height="600" fill={`url(#g${chapter.index})`} />

      {chapter.index === 'I' && (
        <>
          <circle cx="250" cy="160" r="110" fill={color} opacity="0.08" />
          <circle cx="250" cy="160" r="90" fill={color} opacity="0.07" />
          {[0,1,2,3,4,5].map(i => {
            const angle = (i / 6) * Math.PI * 2 - Math.PI / 2;
            return (
              <line key={i} x1="250" y1="240"
                x2={250 + Math.cos(angle) * 160}
                y2={160 + Math.sin(angle) * 200 + 120}
                stroke={color} strokeWidth="3" strokeOpacity="0.25" strokeLinecap="round" />
            );
          })}
          <ellipse cx="250" cy="490" rx="18" ry="30" fill={color} opacity="0.3" />
          <circle cx="250" cy="450" r="12" fill={color} opacity="0.3" />
        </>
      )}

      {chapter.index === 'II' && (
        <>
          <ellipse cx="175" cy="280" rx="80" ry="35" fill={color} opacity="0.12" transform="rotate(-30,175,280)" />
          <ellipse cx="325" cy="280" rx="80" ry="35" fill={color} opacity="0.12" transform="rotate(30,325,280)" />
          <ellipse cx="250" cy="400" rx="22" ry="50" fill={color} opacity="0.22" />
          <circle cx="250" cy="340" r="15" fill={color} opacity="0.22" />
          <circle cx="250" cy="410" r="40" fill={color} opacity="0.05" />
        </>
      )}

      {chapter.index === 'III' && (
        <>
          {/* Ritual circle */}
          <circle cx="250" cy="300" r="100" fill="none" stroke={color} strokeWidth="1" strokeOpacity="0.12" />
          <circle cx="250" cy="300" r="70"  fill="none" stroke={color} strokeWidth="1" strokeOpacity="0.08" />
          <ellipse cx="250" cy="390" rx="20" ry="55" fill={color} opacity="0.2" />
          <circle cx="250" cy="328" r="14" fill={color} opacity="0.2" />
          <polygon points="230,360 210,430 250,420" fill={color} opacity="0.15" />
          <polygon points="270,360 290,430 250,420" fill={color} opacity="0.15" />
          <circle cx="250" cy="400" r="28" fill={color} opacity="0.07" />
        </>
      )}

      {chapter.index === 'IV' && (
        <>
          {/* Water layers */}
          {[0,1,2,3,4].map(i => (
            <ellipse key={i} cx="250" cy={320 + i * 38}
              rx={180 - i * 18} ry="10"
              fill={color} opacity={0.07 - i * 0.01} />
          ))}

          {/* Falling figure */}
          <ellipse cx="250" cy="190" rx="13" ry="34" fill={color} opacity="0.22" transform="rotate(15,250,190)" />
          <circle cx="246" cy="153" r="11" fill={color} opacity="0.22" />
          {/* arms spread */}
          <line x1="237" y1="182" x2="210" y2="200" stroke={color} strokeWidth="3" strokeOpacity="0.18" strokeLinecap="round" />
          <line x1="263" y1="182" x2="290" y2="198" stroke={color} strokeWidth="3" strokeOpacity="0.18" strokeLinecap="round" />

          {/* Creature 1 — large disfigured shark-like, bottom left */}
          <g opacity="0.28">
            {/* body */}
            <ellipse cx="148" cy="490" rx="62" ry="18" fill={color} transform="rotate(-12,148,490)" />
            {/* snout */}
            <polygon points="88,478 72,486 90,494" fill={color} />
            {/* dorsal fin */}
            <polygon points="148,472 158,448 168,472" fill={color} opacity="0.7" />
            {/* tail */}
            <polygon points="208,482 228,468 228,498" fill={color} opacity="0.7" />
            {/* eye */}
            <circle cx="96" cy="486" r="3" fill="#05050a" />
            {/* extra disfigured jaw spines */}
            <line x1="82" y1="487" x2="76" y2="496" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <line x1="86" y1="490" x2="79" y2="500" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <line x1="90" y1="492" x2="85" y2="502" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
          </g>

          {/* Creature 2 — smaller, top right, partially submerged */}
          <g opacity="0.2">
            <ellipse cx="360" cy="395" rx="40" ry="11" fill={color} transform="rotate(8,360,395)" />
            {/* snout */}
            <polygon points="322,390 308,395 323,401" fill={color} />
            {/* dorsal fin */}
            <polygon points="355,384 362,366 370,384" fill={color} opacity="0.7" />
            {/* tail */}
            <polygon points="397,390 412,381 412,400" fill={color} opacity="0.6" />
            {/* eye */}
            <circle cx="318" cy="395" r="2" fill="#05050a" />
            {/* spines */}
            <line x1="311" y1="393" x2="305" y2="400" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <line x1="314" y1="396" x2="308" y2="403" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
          </g>

          {/* Creature 3 — tiny, deep background */}
          <g opacity="0.12">
            <ellipse cx="290" cy="545" rx="30" ry="8" fill={color} transform="rotate(-5,290,545)" />
            <polygon points="263,540 252,545 264,550" fill={color} />
            <polygon points="288,537 293,524 299,537" fill={color} />
            <polygon points="318,542 330,536 330,551" fill={color} />
          </g>
        </>
      )}
    </svg>
  );
}

function LoreChapter({ chapter, chapterColor, animating, chapters, active, onNavigate, label, visible, chapterColors }) {
  return (
    <>
      <div className={styles.illustration}>
        <div className={`${styles.illustInner} ${animating ? styles.exit : styles.enter}`}>
          <IllustrationPlaceholder chapter={chapter} color={chapterColor.color} />
          {ILLUSTRATIONS[chapter.index] && (
            <img 
              key={chapter.index}
              src={ILLUSTRATIONS[chapter.index]} 
              alt={chapter.illustrationAlt || `Chapter ${chapter.index}: ${chapter.title}`} 
              className={styles.illustImg} 
            />
          )}
        </div>

        <div
          className={styles.glow}
          style={{ background: `radial-gradient(ellipse at 40% 50%, ${chapterColor.glow} 0%, transparent 65%)` }}
        />

        <span className={styles.watermark}>{chapter.index}</span>
      </div>

      <div className={styles.content}>
        <div className={styles.accentBar} style={{ background: chapterColor.color }} />

        <p className={`${styles.label} ${visible ? styles.visible : ''}`}>{label}</p>

        <nav className={`${styles.chapterNav} ${visible ? styles.visible : ''}`} aria-label="Chapter navigation">
          {chapters.map((ch, i) => (
            <button
              key={ch.index}
              className={`${styles.chapterBtn} ${active === i ? styles.active : ''}`}
              style={{ '--chapter-color': chapterColors[i]?.color }}
              onClick={() => onNavigate(i)}
              aria-label={`Chapter ${ch.index}: ${ch.title}`}
            >
              {ch.index}
            </button>
          ))}
        </nav>

        <div className={`${styles.contentFade} ${animating ? styles.exit : styles.enter}`}>
          <div className={styles.contentHead}>
            <p className={styles.rune}>{chapter.rune}</p>
            <h2 className={styles.title}>{chapter.title}</h2>
            <p className={styles.subtitle}>{chapter.subtitle}</p>
            <div className={styles.divider} style={{ background: chapterColor.color }} />
          </div>

          <div className={styles.paragraphs}>
            {(chapter.text || []).map((p, i) => (
              <p key={i} className={styles.paragraph}>{p}</p>
            ))}
          </div>

          <div className={styles.arrows}>
            <button
              className={styles.arrowBtn}
              onClick={() => onNavigate(active - 1)}
              disabled={active === 0}
              aria-label="Previous chapter"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M9 2L4 7L9 12" stroke="currentColor" strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button
              className={styles.arrowBtn}
              onClick={() => onNavigate(active + 1)}
              disabled={active === chapters.length - 1}
              aria-label="Next chapter"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M5 2L10 7L5 12" stroke="currentColor" strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoreChapter;
